import { RestService } from 'imnb-common-react';

export default class ServiceClient {
  _serviceRegistry = [];

  addApiEndpoint(serviceConfig) {
    this._serviceRegistry.push(serviceConfig);
    return true;
  }

  requestApi(
    reqOptions = {},
    successCallback = () => {},
    errorCallback = () => {},
    dispatch = ''
  ) {
    return RestService.createInstance(
      reqOptions,
      successCallback,
      errorCallback,
      dispatch
    );
  }
}
